import { Injectable } from '@angular/core';

@Injectable({
  providedIn:'root'
})

export class AccessSecurity {

      public viewDashboard?: boolean = false;

      public createOrder?: boolean = false;
      public editOrder?: boolean = false;
      public viewOrders?: boolean = false;
      public addProduct?: boolean = false;
      public editProduct?: boolean = false;
      public deleteProduct?: boolean = false;
      public viewProducts?: boolean = false;
      public createWorkOrder?: boolean = false;
      public editWorkOrder?: boolean = false;
      public viewWorkOrders?: boolean = false;
      public createInboundOrder?: boolean = false;
      public editInboundOrder?: boolean = false;
      public viewInboundOrders?: boolean = false;
      public stockTransfer?: boolean = false;
      public createCustomer?: boolean = false;
      public editCustomer?: boolean = false;
      public viewCustomers?: boolean = false;
      public viewInvoices?: boolean = false;
      public viewReports?: boolean = false;
      public viewSettings?: boolean = false;
      public editSettings?: boolean = false;
      public payment?: boolean = false;
      public shippingPreferences?: boolean = false;
      public labelPreferences?: boolean = false;
      public returnPreferences?: boolean = false;


//notUsed

     public stockEntryCreate?: boolean = false;
    // public view?: boolean = false;
     public stockTransferCreate?: boolean = false;
     public returnOrders?: boolean = false;
     public configureReturnOptions?: boolean = false;
     public listShipment?: boolean = false;
     public packageTypes?: boolean = false;
}
